// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__VmQyN","label":"Radio_label__1YUnl","checkMark":"Radio_checkMark__2frkU","disabled":"Radio_disabled__3hxXj"};